const defaultStarred = []

const initialState = {
  itens: [],
  discount: 0,
  total: 0,
  attItens: true,
  subtotal: 0,
}

const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ITENS":
      var total;
      var discount;


      if(action.payload.length > 1) {
        total = action.payload.reduce((total, item) => {
            return total + (((item.Valor?item.Valor:0)*(item.Quantidade?item.Quantidade:1)) - ((item.Desconto?+(Math.round(item.Desconto + "e+2")  + "e-2"):0*(item.Quantidade?item.Quantidade:1))))
        }, 0);
        discount = action.payload.reduce((total2, item) => {
          return total2 + ((item.Desconto?+(Math.round(item.Desconto + "e+2")  + "e-2"):0)*(item.Quantidade?item.Quantidade:1))
        }, 0);
      }
      else if(action.payload.length == 1) {
        total = (((action.payload[0].Valor?action.payload[0].Valor:0)*(action.payload[0].Quantidade?action.payload[0].Quantidade:1)) - ((action.payload[0].Desconto?+(Math.round(action.payload[0].Desconto + "e+2")  + "e-2"):0)*(action.payload[0].Quantidade?action.payload[0].Quantidade:1)));
        discount = +(Math.round(action.payload[0].Desconto + "e+2")  + "e-2")*(action.payload[0].Quantidade?action.payload[0].Quantidade:1);
      } 
      else {
        total = 0;
        discount = 0;
      }

      return {
        ...state,
        itens: action.payload,
        discount: discount,
        total: total,
        attItens: true,
        subtotal: total+discount
      }
    default:
      return state
  }
}

export default checkoutReducer
